const getPresentingElement = (
  currentModal?: HTMLIonModalElement | null
): HTMLElement | undefined => {
  const modals = Array.from(
    document.querySelectorAll("ion-modal")
  ) as HTMLIonModalElement[];

  for (let index = modals.length - 1; index >= 0; index -= 1) {
    const modal = modals[index];

    if (modal === currentModal || modal.classList.contains("overlay-hidden")) {
      continue;
    }

    return modal;
  }

  return document.getElementById("ion-page-router") ?? undefined;
};

export default getPresentingElement;
